// frontend/src/pages/RegisterPage.js
import React from 'react';
import RegisterForm from '../components/Auth/RegisterForm';
import { Link } from 'react-router-dom';

const RegisterPage = () => {
  return (
    <div className="min-h-[calc(100vh-var(--navbar-height,88px)-var(--footer-height,88px))] flex flex-col items-center justify-center bg-gradient-to-b from-white to-blue-50 py-12 px-4 sm:px-6 lg:px-8">
    {/* <div className="flex flex-col items-center justify-center flex-grow bg-gradient-to-b from-white to-blue-50 py-12 px-4 sm:px-6 lg:px-8"> */}
      <div className="w-full max-w-md space-y-8">
        <div className="text-center">
            <h2 className="mt-2 text-center text-2xl font-bold tracking-tight text-gray-900">
            Create your account
            </h2>
        </div>

        <RegisterForm />

        <p className="mt-10 text-center text-sm text-gray-500">
          Already have an account?{' '}
          <Link to="/login" className="font-semibold leading-6 text-blue-600 hover:text-blue-500">
            Login here
          </Link>
        </p>
      </div>
    </div>
  );
};

export default RegisterPage;
